const docsBaseUrl = "https://ukorvl.github.io/lightweight-charts-react-components/docs/";
export { docsBaseUrl };
